import script from "./AQToggle.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string%20%7C%20number%20%7C%20boolean"
export * from "./AQToggle.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string%20%7C%20number%20%7C%20boolean"

const __exports__ = script;

export default __exports__